export default "__VITE_ASSET__679707e4__"